import App from '@/models/App'
import Organization from '@/models/Organization'
import Restrict from '@/models/Restrict'

export default class ProfileAttend extends App {
    static get entity() {
        return 'ProfileAttends'
    }
    static one() {
        return this.query().withAllRecursive().first()
    }
    static fields() {
        return {
            id: this.attr(''),
            organizationId: this.attr(''),
            maritimeId: this.attr(''),
            firstName: this.attr(''),
            middleName: this.attr(''),
            lastName: this.attr(''),
            job: this.attr(''),
            email: this.attr(''),
            token: this.attr(''),
            profileImage: this.attr(''),
            organization: this.belongsTo(Organization, 'organizationId'),
            restrict: this.hasOne(Restrict, 'userId'),
            shipSailorId: this.attr(''),
            boarding: this.attr(''),
            sailor: this.attr(''),
        }
    }
    get tokenKey() {
        return `_${this.maritimeId}`
    }
    get anyMiddleName() {
        return this.middleName ?? ''
    }
    get fullName() {
        return `${this.firstName} ${this.anyMiddleName} ${this.lastName}`
    }
    static maritimeId() {
        return this.query().first().maritimeId ?? ''
    }
    static sailorId() {
        return this.query().first().shipSailorId ?? ''
    }
    static boardingId() {
        return this.query().first().boarding
            ? this.query().first().boarding.id
            : ''
    }
    static shipId() {
        return this.query().first().boarding
            ? this.query().first().boarding.shipId
            : ''
    }
    static apiConfig = {
        actions: {
            signin(params) {
                return this.get(`/auth/signin`, {
                    params: {
                        email: params.email,
                        password: params.password,
                    },
                    headers: {
                        'Accept-Language': App.acceptLanguage(),
                    },
                    dataKey: 'profile',
                    baseURL: App.attendURL(),
                    persistOptions: {
                        insertOrUpdate: ['organization', 'restrict'],
                    },
                })
            },
            verify() {
                return this.get(`/auth/verify`, {
                    params: {},
                    headers: {
                        Authorization: 'Bearer ' + App.apiToken(),
                        'Accept-Language': App.acceptLanguage(),
                    },
                    dataKey: 'profile',
                    baseURL: App.attendURL(),
                    persistOptions: {
                        insertOrUpdate: ['organization', 'restrict'],
                    },
                })
            },
            boarding(params) {
                return this.post(`/labor/boardings`, App.post(params), {
                    params: {},
                    headers: {
                        Authorization: 'Bearer ' + App.apiToken(),
                        'Accept-Language': App.acceptLanguage(),
                    },
                    dataKey: 'profile',
                    baseURL: App.attendURL(),
                })
            },
        },
    }
}
